"use client";
import Image from "next/image";
import Link from "next/link";
import { Layout } from "@/components/Layout/Layout";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { JobCard } from "@/components/JobCard/JobCard";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";
import { Heading } from "@/components/Heading/Heading";
import { Paragraph } from "@/components/Paragraph/Paragraph";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { serialize } from "@/app/utils/generateHTML";
export default function Wrapper({ pageData, jobs }) {
	return (
		<Layout>
			<HeroBanner images={pageData.banner.images.map((item) => getImageSrc(item.image.url))} title={HTMLReactParser(pageData.banner.title)} about={HTMLReactParser(pageData.banner.text)} mobileImages={pageData.banner.mobileImages.map((item) => getImageSrc(item.image.url))} alt="Life at Hindustan Power" alts={pageData.banner.images.map((item) => item.image?.alt || "Life at Hindustan Power")} mobileAlts={pageData.banner.mobileImages.map((item) => item.image?.alt || "Life at Hindustan Power")} />
			<section className="py-8 lg:py-16">
				<div className="hp-container flex flex-col items-center">
					<SectionHeading heading={HTMLReactParser(pageData.grow.title)} subHeading={HTMLReactParser(pageData.grow.text)} />
				</div>
			</section>

			<section className="py-16 bg-blue">
				<div className="hp-container">
					<div className="text-left flex flex-col gap-5 lg:gap-8 mb-5">
						<Heading>{HTMLReactParser(pageData.openings.title)}</Heading>
						<Paragraph>{HTMLReactParser(pageData.openings.text)}</Paragraph>
					</div>
				</div>

				<div className="hp-container grid grid-cols-1 items-start mt-12 border-t border-[#D9D9D9]">
					{jobs.map((job) => {
						return (<JobCard key={job.id} title={job.title} location={job.location.title} type={job.type} description={job.description} slug={job.slug} />);
					})}
				</div>
			</section>

			<section className="">
				<div className=" relative flex flex-col items-start lg:items-center justify-start py-12 pb-[30rem] lg:py-40 ">
					<Image alt={pageData.culture.image?.alt || "Life and culture at Hindustan Power"} src={getImageSrc(pageData.culture.image.url)} width={50} height={50} unoptimized className="object-center w-full object-cover absolute top-0 left-0 h-full" />
					<div className="absolute h-full w-full bg-black bg-opacity-50 z-10 top-0 left-0"></div>
					<div className="z-20 relative text-white hp-container w-full lg:pr-[40%] flex flex-col gap-8 text-center lg:text-left">
						<Heading>{HTMLReactParser(pageData.culture.title)}</Heading>
						<div>{serialize(pageData.culture.text)}</div>
					</div>
				</div>
			</section>

			<section className="py-8 lg:py-16">
				<div className="hp-container flex flex-col items-center">
					<div className="flex flex-wrap justify-between lg:justify-center gap-5 xl:gap-12 w-full">
						{pageData.culture.blocks.map((cu, key) => {
							return (
								<div className={`flex flex-col gap-2 justify-center items-start py-8 lg:py-16 px-8 lg:px-12 rounded-[15px] w-full md:w-[30.33%] bg-blue group hover:bg-primary hover:text-white`} key={cu.id}>
									<Heading>{cu.title}</Heading>
									<div className="h-[1px] bg-red w-full my-1 group-hover:bg-white"></div>
									<Paragraph classNames={`text-gray group-hover:text-white`}>{cu.text}</Paragraph>
								</div>
							);
						})}
					</div>
				</div>
			</section>

			<section className="pb-16">
				<div className="hp-container flex flex-col items-center">
					<SectionHeading heading={HTMLReactParser(pageData.values.title)} subHeading={HTMLReactParser(pageData.values.text)} />
					<div className="flex flex-wrap justify-center gap-5 xl:gap-12 w-full">
						{pageData.values.values.map((value) => {
							return (
								<div className="flex flex-col gap-2 justify-center items-center text-center py-8 lg:py-12 md:px-4 xl:px-12 md:w-[30.33%]  border-b md:border-b-0 md:border-r border-[#D9D9D9]" key={value.id}>
									<Image alt={value.icon?.alt || value.title} src={getImageSrc(value.icon.url)} width={60} height={60} unoptimized className="" style={{ width: '56px', height: 'auto', }} />
									<h4 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-medium leading-[24px] lg:leading-[32px]">{value.title}</h4>
									<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal text-gray">{value.text}</p>
								</div>
							);
						})}
					</div>
				</div>
			</section>
		</Layout>
	);
}
